import type { ID } from '@octopus-do/octopus-project-core'
import { createAction } from '@reduxjs/toolkit'

export const ReportExportActions = {
  pdf: createAction<ID>('REPORT_EXPORT_PDF'),
}
